import { AppName } from "assets/app/app-name";
import { useLangContext } from "context/Lang"


export const Footer = () => {
    const { gW } = useLangContext();
    return (
        <footer className="border-t border-primary-600 bg-primary-900 text-primary-50">
            <div className=" mx-auto px-6 py-12">
                <div className=" border-primary-700  text-center text-sm text-primary-300">
                    <p>
                        © 2025 <AppName />  — {gW("rights-reserved")}
                    </p>
                </div>

            </div>
        </footer>
    )
}
